import React from "react";
import { Star } from "lucide-react";
import { ShirtKit } from "./ShirtKit";

const lastName = (n) => n.split(" ").slice(1).join(" ") || n;

const Badge = ({ letter }) => (
  <span
    data-testid={`armband-${letter}`}
    className="absolute -top-1 -left-1 sm:left-0 w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-[#1a1a1a] border border-white text-white text-[9px] sm:text-[10px] font-extrabold flex items-center justify-center"
  >
    {letter}
  </span>
);

const StarBadge = () => (
  <span
    data-testid="star-player-badge"
    title="Player of the Season"
    className="absolute -top-1 -right-1 sm:right-0 w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-[#FFD700] border border-white flex items-center justify-center"
  >
    <Star className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-[#0F172A] fill-[#0F172A]" />
  </span>
);

const nameTagClass = (p, highlight, star) =>
  highlight
    ? "bg-[#10B981] text-[#0F172A]"
    : star
    ? "bg-[#FFD700] text-[#0F172A]"
    : p
    ? "bg-white text-[#0F172A]"
    : "bg-white/70 text-[#0F172A]/70";

// One shirt + FPL name/fixture tags on the pitch.
export const PitchPlayer = ({ slot, armband, highlight, onPlace, onCaptain, points, star }) => {
  const p = slot.player;
  const click = highlight ? onPlace : p && onCaptain ? onCaptain : undefined;
  return (
    <div
      data-testid={`pitch-slot-${slot.id}`}
      onClick={click}
      className={`relative flex flex-col items-center w-[62px] sm:w-[84px] ${click ? "cursor-pointer" : ""} ${p ? "fpl-pop" : ""}`}
    >
      <div className={`relative text-white ${highlight ? "animate-pulse scale-110" : ""} ${p && onCaptain ? "hover:scale-110" : ""} transition-transform duration-200`}>
        <ShirtKit short={p?.short} color={p?.color} isGK={slot.cat === "GK"} empty={!p} className="w-10 h-10 sm:w-14 sm:h-14" />
        {armband && <Badge letter={armband} />}
        {star && <StarBadge />}
        {highlight && <span className="absolute inset-0 rounded-full ring-2 ring-[#10B981] ring-offset-0 blur-[1px]" />}
      </div>
      <div className={`w-full text-center truncate px-1 py-[1px] text-[10px] sm:text-[12px] font-bold rounded-t-[3px] ${nameTagClass(p, highlight, star)}`}>
        {p ? lastName(p.name) : slot.label}
      </div>
      <div className="w-full text-center truncate px-1 py-[1px] text-[9px] sm:text-[11px] font-semibold rounded-b-[3px] bg-[#0F172A] text-white">
        {p && points !== undefined ? (
          <span data-testid={`player-points-${slot.id}`} className={star ? "text-[#FFD700]" : "text-[#10B981]"}>{points} pts</span>
        ) : p ? (
          <>
            {p.short} <span className="text-[#10B981]">{p.rating}</span>
          </>
        ) : (
          <span className="text-white/85">{highlight ? "Tap to place" : "Empty"}</span>
        )}
      </div>
    </div>
  );
};

export default PitchPlayer;
